/* eslint-disable no-unused-vars */
import { useState, useEffect, Dispatch, SetStateAction } from "react";

import { IOptions, Prefecture } from "@lhd/types";
import { PERMISSIONS } from "@lhd/constants";
import { useFetchPrefectures } from "@lhd/hooks";

type ITreeData = {
  title: string;
  expanded?: boolean;
  children?: {
    title: string;
  }[];
}[];

export type ReceivedProps = {
  showPrefecture?: boolean;
  showPermission?: boolean;
  treeData: ITreeData;
  placeholder?: string;
  setTreeData: Dispatch<SetStateAction<ITreeData>>;
  updateTreeData: (treeData: ITreeData) => void;
  removeNode: (node: any, path: any) => void;
  selectThis: (node: any, path: any) => void;
  insertNewNode?: (path: any) => void;
};

export const DEFAULT_CHECKED = [
  PERMISSIONS["human_resource_management"],
  PERMISSIONS["labor_management"],
  PERMISSIONS["company_management"],
  PERMISSIONS["operational_management"],
  PERMISSIONS["full_permission"],
];

const useDiagram = (props: ReceivedProps) => {
  const { data: prefectureData, isLoading, isSuccess } = useFetchPrefectures();
  const [prefectureOptions, setPrefectureOptions] = useState<IOptions>();

  useEffect(() => {
    if (props?.showPrefecture && isSuccess) {
      const seenValues = new Set<number>();
      const options = (prefectureData as Prefecture[]).reduce(
        (acc: any[], item) => {
          const normalizedValue = +item.code;
          if (seenValues.has(normalizedValue)) {
            return acc;
          }
          seenValues.add(normalizedValue);
          acc.push({
            value: normalizedValue,
            label: item.name,
          });
          return acc;
        },
        [],
      );
      setPrefectureOptions(options);
    }
  }, [isSuccess, prefectureData, props?.showPrefecture]);

  return {
    ...props,
    isLoading,
    prefectureOptions,
  };
};

export type Props = ReturnType<typeof useDiagram>;

export default useDiagram;
